// import { BuyPage } from './../buy/buy';
import { MediaService } from './../../service/media.service';
import { Injectable } from '@angular/core';
import { PlayerService } from './../../service/player.service';
import { album } from './../../models/album.model';
import { media } from "./../../models/media.model";
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { PlayerPage } from '../player/player';

/**
 * Generated class for the AlbumPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Injectable()

@Component({
  selector: 'page-album',
  templateUrl: 'album.html',
})
export class AlbumPage {

  item:album = new album();

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public pService: PlayerService,
    private mService: MediaService
    ) {
      this.item = navParams.get("item");
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AlbumPage');
  }

  play(media_id: number)
  {

    this.mService.load(media_id).then((item: media)=> {

      if (item.access)
      {
        this.pService.playList = this.item.medias;
        this.pService.playId(media_id);

        if (item.type == 'vimeo')
        {
          this.navCtrl.push(PlayerPage);
        }
      }
      else
      {
      //  this.navCtrl.push(BuyPage, {media_id: media_id});
      }


    });

  }

}



// WEBPACK FOOTER //
// ./src/pages/album/album.ts